import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header w-full bg-primary text-base text-neutral-50" }
const _hoisted_2 = { class: "container mx-auto py-2" }
const _hoisted_3 = { class: "header__content flex justify-between items-center" }
const _hoisted_4 = { class: "nav flex justify-between items-center gap-4 text-xl font-medium" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Maps")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Timer")

import AppLogo from "@/components/AppLogo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppLogo),
        _createElementVNode("nav", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/maps" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/timer" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})